import { Bell, X } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { ReactNode } from 'react'

interface NotificationBannerProps {
  message: string
  variant?: 'success' | 'warning'
  onDismiss?: () => void
  action?: ReactNode
}

const NotificationBanner = ({
  message,
  variant = 'success',
  onDismiss,
  action,
}: NotificationBannerProps) => {
  const bgColor = variant === 'success' ? 'bg-[#F4DB66]' : 'bg-[#DA9B8E]'

  return (
    <div className={`${bgColor} rounded-2xl p-6`}>
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-4 flex-1">
          <div className="shrink-0 w-12 h-12 rounded-full border-2 border-black flex items-center justify-center">
            <Bell className="w-5 h-5 text-black" />
          </div>
          <p className="text-black font-semibold text-[14px] leading-relaxed flex-1">{message}</p>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          {action}
          {onDismiss && (
            <Button
              variant="ghost"
              size="icon"
              onClick={onDismiss}
              className="rounded-full hover:bg-black/10 text-black"
            >
              <X className="w-5 h-5" />
            </Button>
          )}
        </div>
      </div>
    </div>
  )
}

export default NotificationBanner
